import React, { FC, memo, useCallback, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router-dom'
import { useInView } from 'react-intersection-observer'

import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'

import { ButtonMUI } from 'components/ButtonMUI'
import { TitleBottomSection } from 'components/TitleBottomSection'
import { ImagesPalette } from 'components/ImagesPalette'
import { World } from './World'

import { staticMultimedia } from 'utils'

import styles from './styles.module.scss'


interface IProps {
}

const imagesPalette = [
  [staticMultimedia.SDKImage1, staticMultimedia.SDKImage2],
  [staticMultimedia.SDKImage3, staticMultimedia.SDKImage4, staticMultimedia.SDKImage5],
  [staticMultimedia.SDKImage6, staticMultimedia.SDKImage7],
  [staticMultimedia.SDKImage8, staticMultimedia.SDKImage9, staticMultimedia.SDKImage10]
]

const unitySDKVersion = '(2021.3.30 LTS)'

const UnitySection: FC<IProps> = props => {
  const { ref: contentBlockRef, inView, entry } = useInView({
    threshold: 0.1
  })

  return (
    <SectionContainer>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.unityContainer}>
          <div ref={contentBlockRef} className={styles.contentBlock}>
            <div className={styles.descriptionBlock}>
              <TitleSection title={'Somnium Unity SDK'}
                            subTitle={'Virtually Limitless Capabilities'}/>
              <div className={styles.descriptionBlockInner}>
                <div className={styles.unitySDKBox}>
                  <img
                    src={staticMultimedia.unitySDKLogo}
                    className={styles.unitySDKLogo} alt="unitySDKLogo"/>
                  <span>{unitySDKVersion}</span>
                </div>

                <div className={styles.description}>
                  Embark on a journey of creative exploration with the Somnium Unity SDK. Craft intricate virtual
                  experiences that transcend reality within the expansive canvas of Somnium Space.
                  <br/><br/>
                  This SDK empowers you to seamlessly blend your imaginative concepts with the immersive environment,
                  offering unparalleled opportunities to shape and share your vision.
                  <br/><br/>
                  Whether you're an experienced developer or a newcomer to virtual worlds, the Somnium Unity SDK opens
                  the
                  door to a realm of endless creative expression. Dive into the possibilities and watch your ideas come
                  to
                  life in ways you never thought possible.
                </div>
                <div className={styles.somniumWorlds}>
                  <img src={staticMultimedia.somniumWorldsLogo} className={styles.somniumWorldsLogo} alt="WorldsLogo"/>

                  {inView
                    ? <div className={styles.worldsType}>
                      <World type={'S'}/>
                      <World type={'M'}/>
                      <World type={'XL'}/>
                    </div>
                    : null}
                </div>
              </div>
            </div>

            <div className={styles.imagesBlock}>
              <ImagesPalette palette={imagesPalette}/>
            </div>

          </div>
          <div className={styles.bottomBlock}>
            <TitleBottomSection
              title={'Get started now!'}
              subTitle={<>Download our Somnium SDK guide to seamlessly integrate your creations into the metaverse.<br/>
                Join our thriving creator community!</>}/>
            <div className={styles.rightBox}>
              <NavLink to="/documentation">
                <ButtonMUI styleType={'white'}
                           type="button"
                           sx={{
                             '&&': {
                               width: '215px',
                               height: '60px',
                               borderRadius: '30px'
                             }
                           }}>Documentation</ButtonMUI>
              </NavLink>
              <ButtonMUI styleType={'white'}
                         onClick={() => {
                           window.open('https://somniumspace.com/files/SomniumSpaceSDK.unitypackage', '_self', 'noopener,noreferrer')
                         }}
                         type="button"
                         sx={{
                           '&&': {
                             width: '215px',
                             height: '60px',
                             borderRadius: '30px'
                           }
                         }}>Download SDK</ButtonMUI>
            </div>
          </div>

        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(UnitySection)
